import axiosInstance from "./axios";

export const bellNotification = async (params) =>
  axiosInstance.get(
    `/api/v1/notification/get-notification/?order=true${params}`
  );

export const allNotifications = async (params) =>
  axiosInstance.get(`/api/v1/notification/get-notification/${params}`);
